import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from './context';
class SetThemeInContext extends React.PureComponent {
  getChildContext() {
    return {
      hasTheme: true,
      theme: this.props.theme
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: this.getChildContext()
    }, this.props.children);
  }
}
// @ts-expect-error
SetThemeInContext.childContextTypes = {
  hasTheme: PropTypes.bool,
  theme: PropTypes.object
};
export { SetThemeInContext };
//# sourceMappingURL=SetThemeInContext.js.map